import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { useLocation } from "react-router-dom";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="http://lanunion.cqu.edu.cn/">
        重庆大学蓝盟
      </Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  footer: {
    padding: theme.spacing(2),
    bottom: 0,
    marginTop: 100,
    backgroundColor: theme.palette.primary.light
  }
}));

export default function StickyFooter() {
  const classes = useStyles();
  const { pathname } = useLocation();

  if (pathname.includes("admin")) {
    return null;
  }

  return (
    <footer className={classes.footer}>
      <Container maxWidth="sm">
        <Typography variant="body1" align="center" color="textPrimary">
          页脚
        </Typography>
        <Copyright />
      </Container>
    </footer>
  );
}
